import React, { Fragment, useRef, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap, Polyline, Circle, Polygon } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { useEffect } from 'react';
import 'leaflet.fullscreen/Control.FullScreen.js';
import 'leaflet.fullscreen/Control.FullScreen.css';
import { ReactComponent as TruckSvg } from '../../Svgs/Mapa/truck.svg';
// import { ReactComponent as MarkerSvg } from '../../Svgs/Mapa/marker.svg';
import ReactDOMServer from 'react-dom/server';

delete (L.Icon.Default as any).prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default function MapComponent(props:any) {
    const [marcadores, setMarcadores] = useState<any[]>([]);
    const mapRef = React.useRef<any>(null);
    const fullscreenAdded = useRef(false);

    useEffect(() => {
        // setTimeout(() => {
            setMarcadores(props.marcadores);    
            //console.table(props.marcadores);
        // }, 5000);
        

        // let mapInst = mapRef.current.leafletElement;
        // const group = mapRef.current.leafletElement; //get native featureGroup instance
        // mapInst.fitBounds(group.getBounds());
        
    }, [props.marcadores]);

    function FullscreenControl() {
      const map = useMap();
    
      useEffect(() => {
        if (fullscreenAdded.current || !map) {
          return;
        }

        fullscreenAdded.current = true;
        L.control.fullscreen({ position: 'topright' }).addTo(map);
      }, [map]);
    
      return null;
    }

    // function AjustarMapa({ pontos }:any) {
    //     const map = useMap();
      
    //     useEffect(() => {
    //       // Filtra pontos válidos com lat e lng definidos
    //       const pontosValidos = pontos.filter((p:any) => 
    //         typeof p.lat === 'number' && typeof p.lng === 'number'
    //       );
      
    //       if (pontosValidos.length === 0) return;
      
    //       const bounds = L.latLngBounds(pontosValidos.map((p:any) => [p.latitude, p.longitude]));
    //       map.fitBounds(bounds, { padding: [50, 50] });
    //     }, [pontos, map]);
      
    //     return null;
    //   }

    const FitBounds = ({ pontos }: { pontos: any[] }) => {
        const map = useMap();
      
        useEffect(() => {
          if (pontos.length > 0) {
             const pontosValidos = pontos.filter((p:any) => 
                typeof p.latitude === 'number' && typeof p.longitude === 'number'
              );
          
              if (pontosValidos.length === 0) return;

            const bounds:any = pontos.map(p => [p.latitude??0, p.longitude??0]);
            map.fitBounds(bounds);
          }
        }, [pontos, map]);
      
        return null;
      };
      
      function colorIcon(color:any, type:any=null) {
        color ??= 'blue';
        if (type == 'truck') {
          return L.divIcon({
            className: 'custom-marker',
            html: ReactDOMServer.renderToStaticMarkup(<TruckSvg />),
            iconSize: [45, 45],
            iconAnchor: [15, 30],
            popupAnchor: [0, -30],
          });
        }
        return new L.Icon({
            iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-${color}.png`,
            shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        });
        }
      
    return (
      <MapContainer ref={mapRef} center={[-23.55052, -46.633308]} zoom={9} style={{ height: props.height, minHeight: props.minHeight, width: '100%' }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FullscreenControl />
        {marcadores?.map((marcador: any, index: number) => (
          <Fragment key={index}>
          <Marker
              position={[marcador.latitude ?? 0, marcador.longitude ?? 0]}
              icon={colorIcon(marcador.cor, marcador.type)}
            >
              <Popup>{marcador.dados}</Popup>
          </Marker>

            {marcador.raio && (
              <Circle
                center={[marcador.latitude ?? 0, marcador.longitude ?? 0]}
                radius={marcador.raio}
                pathOptions={{ weight: 1, color: marcador.cor || 'blue', fillOpacity: 0.2 }}
              />
            )}
        
            {((marcador.poligono??'')=='' ? '' :
              <Polygon
                  positions={JSON.parse(marcador.poligono)[0].map(([lat, lng]:any) => [lng, lat])}
            pathOptions={{
                  weight: 5,
                  color: marcador.color,
                  fillColor: marcador.color,
                  fillOpacity: 0.5 
            }}
          />)}
          </Fragment>
        ))}
        
        {(marcadores==null || marcadores.length == 0 ? '' : <FitBounds pontos={marcadores} />)}
        {((props.posicoes??'')=='' ? '' :
          <Polyline positions={props.posicoes}
            pathOptions={{
              color: 'red',
              weight: 2,
              dashArray: '5',
              lineCap: 'round',
            }}
        />)}
        
        {((props.coordenadas??'')=='' ? '' :
          <Polyline positions={props.coordenadas}
            pathOptions={{
              weight: 5
            }}
          />)}
      </MapContainer>
    );
  }
  